import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ChevronLeft } from 'lucide-react';

interface Props {
  /** If provided, renders as a Link. */
  to?: string;
  /** If provided (and `to` is not), renders as a button calling this handler. */
  onClick?: () => void;
  /** Custom label; defaults to `t('admin.back')`. */
  label?: string;
}

/**
 * Header back affordance: ChevronLeft + label, styled with `btn-ghost`.
 * Renders a `<Link>` when `to` is given, a `<button>` (defaults to
 * `navigate(-1)`) otherwise.
 */
export function BackButton({ to, onClick, label }: Props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const text = label ?? t('admin.back');
  const className = 'btn-ghost h-8 px-2 text-sm';

  if (to) {
    return (
      <Link to={to} className={className} aria-label={text}>
        <ChevronLeft className="h-4 w-4" />
        {text}
      </Link>
    );
  }

  return (
    <button
      type="button"
      className={className}
      onClick={onClick ?? (() => navigate(-1))}
      aria-label={text}
    >
      <ChevronLeft className="h-4 w-4" />
      {text}
    </button>
  );
}
